<template>
    <div>
        <div class="sub-lnb-menu">
            <ul class="sub-lnb-menu__list">
                <li class="sub-lnb-menu__item" :class="{active: this.lnbIndex==1}" @click="lnbFn(1)">
                    <div class="line"></div>
                    <a href="javascript:;" @click.prevent="scrollTo('step1')">Эрчимт эмчилгээний тасагт үзүүлэх үйлчилгээ болон анхаарал зүйлс </a>
                </li>
                <li class="sub-lnb-menu__item" :class="{active: this.lnbIndex==2}" @click="lnbFn(2)">
                    <div class="line"></div>
                    <a href="javascript:;" @click.prevent="scrollTo('step2')">Бэлдэх зүйлс</a>
                </li>
                <li class="sub-lnb-menu__item" :class="{active: this.lnbIndex==3}" @click="lnbFn(3)">
                    <div class="line"></div>
                    <a href="javascript:;" @click.prevent="scrollTo('step3')">Эмчийн үзлэг</a>
                </li>
                <li class="sub-lnb-menu__item" :class="{active: this.lnbIndex==4}" @click="lnbFn(4)">
                    <div class="line"></div>
                    <a href="javascript:;" @click.prevent="scrollTo('step4')">Хоолны хуваарь</a>
                </li>
                <li class="sub-lnb-menu__item" :class="{active: this.lnbIndex==5}" @click="lnbFn(5)">
                    <div class="line"></div>
                    <a href="javascript:;" @click.prevent="scrollTo('step5')">Эргэлтийн хуваарь болон анхаарах зүйлс</a>
                </li>
                <li class="sub-lnb-menu__item" :class="{active: this.lnbIndex==6}" @click="lnbFn(6)">
                    <div class="line"></div>
                    <a href="javascript:;" @click.prevent="scrollTo('step6')">Бусад</a>
                </li>
                <li class="sub-lnb-menu__item" :class="{active: this.lnbIndex==7}" @click="lnbFn(7)">
                    <div class="line"></div>
                    <a href="javascript:;" @click.prevent="scrollTo('step7')">Эрчимт эмчилгээний тасагт хэвтэх үед шаардлагатай эд зүйлсийн жагсаалт</a>
                </li>
            </ul>
        </div>

        <div class="subSwiper info" v-if="$store.getters.getHost == 'H0006'">
            <swiper :cssMode="true" :navigation="{
					nextEl: '.subSwiper-next',
					prevEl: '.subSwiper-prev'
				}" :pagination="{ clickable: true }" :mousewheel="true" :keyboard="true" :modules="modules">
                <swiper-slide>
                    <img src="/resource/img/info-img02.jpg" alt="">
                </swiper-slide>
                <swiper-slide>
                    <img src="/resource/img/info-img03.jpg" alt="">
                </swiper-slide>
                <swiper-slide>
                    <img src="/resource/img/info-img04.jpg" alt="">
                </swiper-slide>
            </swiper>
            <div class="subSwiper-bth subSwiper-next"></div>
            <div class="subSwiper-bth subSwiper-prev"></div>
        </div>

        <!-- 뇌혈관 -->
        <div class="subSwiper info" v-else>
            <swiper :cssMode="true" :pagination="{ clickable: true }" :mousewheel="true" :keyboard="true" :modules="modules">
                <swiper-slide>
                    <img src="/resource/img/intensive01-brain.jpg" alt="">
                </swiper-slide>
            </swiper>
        </div>

        <div id="step1" class="step-item info">
            <h3 class="bullet01">Эрчимт эмчилгээний тасагт үзүүлэх үйлчилгээ болон анхаарал зүйлс </h3>
            <p class="bullet04 num1 depth">
                Биеийн байрлалаа өөрчлөх, сорох, хэсэгчлэн усанд орох, шээх, өтгөнийг янзлах, хооллоход туслах зэрэг асаргааны үндсэн тусламж үйлчилгээгээр хангана. 
            </p>
            <p class="bullet04 num2 depth">
                Яаралтай тусламжийн үед дуудах арга : Яаралтай үед эсвэл сувилагчаас тусламж авах шаардлагатай үед орны хажууд буй яаралтай тусламжийн хонхыг дарж сувилагчийг дуудвал тэр даруй яаралтай тусламж үйлчилгээг авах боломжтой. 
            </p>
            <p class="bullet04 num3 depth">
                Халдварын хяналт болон эрчимт эмчилгээний тасгийн тусгай эмчилгээ хийхийн тулд эрчимт эмчилгээний тасаг дотор өрөөг солих боломжтой. 
            </p>
            <p class="bullet04 num4 depth">
                <span>
                    Төрөл бүрийн гуурс(катетер, дренаж хоолой, гуурс зэрэг) болон хиймэл амьсгалын аппарат зэрэг өвчтөний амьсгалын болон зүрх судасны системд шууд нөлөөлдөг эмнэлгийн багаж хэрэгсэл, тоног төхөөрөмжийг ашиглах, өөрийгөө гэмтээх болон бусдыг гэмтээхээс урьдчилан сэргийлэхийн тулд 
                    <span class="font-main">бие хамгаалах хэрэгсэлийг ашиглах боломжтой бөгөөд </span> 
                    дараах дараалалын дагуу хийнэ. 
                </span>
            </p>
            <p class="bullet05 depth">
                Бие хамгаалах хэрэгслийг ашиглах шаардлагатай талаар өвчтөн болон асран хамгаалагчид хариуцагч эмч нь тайлбарласны дараа ашиглах боломжтой ба хэрэглэх хэсгийг дор хаяж 2 цаг тутамд шалгана. 
            </p>
            <p class="bullet05 depth">
                Яаралтай нөхцөл байдлаас хамааран эмнэлгийн ажилтан эхлээд ашигласаны дараа асран хамгаалагчид тайлбарлах боломжтой. 
            </p>
            <p class="bullet04 num5 depth">
                Өвчтөн эмнэлэгт хэвтэхээс өмнө ууж буй эмийн талаар хариуцагч эмч болон сувилагчид мэдэгдэхийг хүсч байна. Эмнэлэгт хэвтэхээс өмнө ууж байсан эмээ үргэлжлүүлэн дур мэдэн уух боломжгүй. 
            </p>
        </div>
        <div id="step2" class="step-item info">
            <h3 class="bullet01">Бэлдэх зүйлс</h3>
            <p class=" depth">Өвчтөний хэрэглэх нойтон сальфетка, живх, дэвсгэр, маскаа бэлдэнэ үү. </p>
        </div>
        <div id="step3" class="step-item info">
            <h3 class="bullet01">Эмчийн үзлэг</h3>
            <p class="bullet04 num1 depth">Үдээс өмнө 8 цаг~10 цагийн хооронд эмчийн үзлэг хийх бөгөөд клиникийн нөхцөл байдлаас хамааран өөрчлөгдөх боломжтой. </p>
            <p class="bullet04 num2 depth">Үзлэгийн үед эмчтэй уулзахыг хүсвэл хариуцаж буй сувилагчид мэдэгдэнэ үү. </p>
        </div>
        <div id="step4" class="step-item info">
            <h3 class="bullet01">Хоолны хуваарь</h3>
            <p class="bullet04 num1 depth">
                Хооллох боломжтой өвчтөний хоолны цагийн хувьд өглөөний хоол : үдээс өмнө 7 цаг ~8 цаг, өдрийн хоол : үдээс хойш 12 цаг ~1 цаг, оройн хоол : үдээс хойш 6 цаг ~7 цаг. 
            </p>
            <p class="bullet04 num2 depth">
                Өвчтөний хүсэлтээр даатгалын хөнгөлөлтгүй ‘тусгай хоол’-г сонгох боломжтой бөгөөд энэ тохиолдолд бүх зардлыг өвчтөн өөрөө хариуцна. 
            </p>
        </div>
        <div id="step5" class="step-item info">
            <h3 class="bullet01">Эргэлтийн хуваарь болон анхаарах зүйлс </h3>
            <p class="bullet04 num1 depth">Эргэлтийн тогтмол хуваарь </p>
            <div class="table mt20 ">
                <div class="table__inner">
                    <table>
                        <colgroup>
                            <col style="width:25%;">
                            <col style="width:25%;">
                            <col style="width:25%;">
                            <col style="width:25%;">
                        </colgroup>
                        <thead>
                            <tr>
                                <th colspan="2">Ангилал</th>
                                <th>Гариг</th>
                                <th>Цаг</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td rowspan="2">Нэгдсэн эрчимт эмчилгээний тасаг</td>
                                <td>Мэдрэлийн эрчимт эмчилгээний тасаг</td>
                                <td>өдөр бүр</td>
                                <td rowspan="4">13:00 ~ 13:20</td>
                            </tr>
                            <tr>
                                <td>Дотрын эрчимт эмчилгээний тасаг</td>
                                <td>өдөр бүр</td>
                            </tr>
                            <tr>
                                <td rowspan="2">Гэмтлийн эрчимт эмчилгээний тасаг</td>
                                <td>Гэмтлийнэрчимт эмчилгээний тасаг</td>
                                <td>өдөр бүр</td>
                            </tr>
                            <tr>
                                <td>Зүрх судасны эрчимт эмчилгээний тасаг</td>
                                <td>өдөр бүр</td>
                            </tr>
                            <tr>
                                <td>Аортын судасны эрчимт эмчилгээний тасаг</td>
                                <td>Аортын судасныэрчимт эмчилгээний тасаг</td>
                                <td>өдөр бүр</td>
                                <td>12:30 ~ 12:50</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
            <p class="bullet04 num2 depth mt20">
                Эргэлтийн үед тухайн эрчимт эмчилгээний тасгийн нөхцөл байдлаас шалтгаалан эргэлт орохыг хязгаарлах болон хойшлуулах боломжтой. 
            </p>
            <p class="bullet04 num3 depth">
                Халдварын хяналт хийхийн тулд эргэлтээр орох хүнийг 1 хүн-ээр хязгаарлаж, ээлжлэн орохыг хориглоно. 
            </p>
            <p class="bullet04 num4 depth">
                Өвчтөний амар тайван байдал болон халдварын хяналтыг хэрэгжүүлэхийн тулд дархлаа сул байдаг 12-оос доош настай хүүхэд болон ханиад, халдварт өвчтэй гэр бүлийн гишүүдийн уулзалтыг хориглох бөгөөд эргэлтийн цагийг баримтална уу. 
            </p>
            <p class="bullet04 num5 depth">
                Эргэлтээр орохын өмнө болон дараа гар ариутгагч хэрэглэх юмуу эрчимт эмчилгээний үүдэнд байрлуулсан угаалтуурт гараа заавал угаана уу. 
            </p>
            <p class="bullet04 num6 depth">
                Эргэлтээр орох үед эрчимт эмчилгээний тасгийн үүдэнд байрлуулсан гялгар уутан халаадыг өмсөж эрчимт эмчилгээний тасгаас гарахаас өмнө тайлсны дараа гарна уу. 
            </p>
            <p class="bullet04 num7 depth">
                Эргэлтийн үед унаж, ойчихоос сэргийлэхийн тулд дараах зүйлсийг сахина уу. 
            </p>
            <p class="bullet05 depth">Орны хашлалыг үргэлж хоёр талыг нь байнга дээшлүүлж хийнэ үү. </p>
            <p class="bullet05 depth">Тусламж хэрэгтэй бол сувилагчийг дуудах юмуу залгана уу. </p>
            <p class="bullet04 num8 depth">Гар утас нь радио долгионы нөлөөллөөс болж эмнэлгийн тоног төхөөрөмжинд гэмтэл учруулж болзошгүй тул эрчимт эмчилгээний тасагт орохдоо заавал утсаа унтраана уу. </p>
            <p class="bullet04 num9 depth">Эргэлтээр уулзаж байх үедээ өвчтөнд хэвийн бус шинж тэмдэг(ухаан санааны өөрчлөлт, цээжээр өвдөх, цус алдах, таталт, өвдөх гэх мэт) илэрвэл нэн даруй эмнэлгийн ажилтнуудад мэдэгдэнэ үү. </p>
            <p class="bullet04 num10 depth">
                Өвчтэй хүүхдийн хувьд хулгайлагдахаас урьдчилан сэргийлэх, аюулгүй байдлыг хангах үүднээс эргэлт хийх үед иргэний үнэмлэхийг шалгах боломжтой. 
            </p>
            <p class="bullet04 num11 depth">
                Эргэлтээр ирсэн зочдыг хянахын тулд нэрсийн жагсаалтад нэрээ бичихийг хүсч байна. 
            </p>
        </div>

        <div id="step6" class="step-item info">
            <h3 class="bullet01">Бусад</h3>
            <h4 class="bullet02 type2 num1 depth">Үйлчилгээний байгууламж </h4>
            <p class="depth">
                Эмнэлгийн төлбөр тооцооны машин, видео CD бүртгэлийн машин, хүнсний дэлгүүр, банк, кофе шоп, хоолны газар, нарийн боовны газар, эмнэлгийн хэрэгсэл, хүнгүй хүргэлтийн хайрцаг зэрэг байгаа. 
            </p>

            <h4 class="bullet02 type2 num2 depth">
                Гал түймрээс урьдчилан сэргийлэх, хариу арга хэмжээ авах арга 
            </h4>
            <p class="depth">
                Гэр бүлийн хүлээлгийн өрөөнд зөөврийн газын плитка, сэнс, цахилгаан халаагуур ашиглах болон шатамхай материал, бодис оруулахыг хориглоно. Гал гарсан тохиолдолд сувилагчид нэн даруй мэдэгдэж, эмнэлгийн ажилтнуудын зааврын дагуу дайжих өрөө болон яаралтай үед ашиглах шатаар гарахыг хүсч байна. 
            </p>

            <h4 class="bullet02 type2 num3 depth">Тамхи татахыг хориглоно </h4>
            <p class="depth">Эмнэлэг нь өвчтөнүүдийн эрүүл мэнд , гал түймрээус урьдчилан сэргийлэх үүднээс эмнэлгийн бүх хэсэгт тамхи татахыг хориглодог тул тамхи татахгүй байхыг хүсье.</p>

            <h4 class="bullet02 type2 num4 depth">Өргөдөл гомдол шийдэх </h4>
            <p class="depth">Эмнэлэгээр үйлчлүүлэх үед асуухыг хүссэн зүйл болон тав тухгүй байсан зүйлс, магтахыг хүссэн зүйлсээ 1 давхарын хэрэглэгчийн сэтгэл ханамжийн өрөөнд зочлох юмуу, утсаар, эмнэлгийн цахим хуудсаар дамжуулан үйлчлүүлэгчийн дуу хоолойгоо дамжуулах боломжтой.</p>

            <h4 class="bullet02 type2 num5 depth">Машины зогсоолын төлбөр</h4>
            <p class="depth">Эрчимт эмчилгээний тасгийн үүдний самбарт бичигдсэн машины зогсоолын талаарх зааврыг харна уу. </p>

            <h4 class="bullet02 type2 num6 depth">Эд зүйлээ алга болгох, алдахаас сэргийлнэ үү </h4>
            <p class="depth">
                Үнэт эдлэл болон бэлэн мөнгө эрчимт эмчилгээний тасагт хадгалах боломжгүй. Хувьдаа хадгалах юмуу удирдлагын хэлтэс рүү холбогдохыг хүсч байна. Хиймэл шүд, сонсголын аппарат, нүдний шил, ленз зэрэг хэрэгсэлээ шинжилгээ өгөх, мэс засал, мэс ажилбарын үед тайлан авч хадгалахдаа анхаарна уу. 
                <br>
                Өөрийн анхаарал болгоомжгүй байдлаас болж эд зүйлсээ алдсан тохиолдолд эмнэлэгээс хариуцлага хүлээхгүй болно. 
            </p>

            <h4 class="bullet02 type2 num7 depth">Хувийн эд зүйлээ хянах </h4>
            <ul class="bullet-list type2 depth">
                <li class="bullet-item">нүдний шил </li>
                <li class="bullet-item">хиймэл шүд </li>
                <li class="bullet-item">сонсголын аппарат </li>
                <li class="bullet-item">түрийвч</li>
                <li class="bullet-item">гар утас </li>
                <li class="bullet-item">хувцас</li>
                <li class="bullet-item">гутал </li>
                <li class="bullet-item">түлхүүр </li>
                <li class="bullet-item">цаг</li>
                <li class="bullet-item">ээмэг </li>
                <li class="bullet-item">зүүлт</li>
                <li class="bullet-item">бөгж </li>
                <li class="bullet-item">бугуйвч</li>
                <li class="bullet-item">хөлний бугуйвч </li>
                <li class="bullet-item">бусад ( <span class="gap50"></span> )-г  (Нэр: <span class="gap100"></span>Хамаарал: <span class="gap100"></span>) -нд дамжуулав. </li>
            </ul>


            <h4 class="bullet02 type2 num8 depth">Шашны байгууламж ашиглах заавар </h4>
            <p class="depth">
                Манай эмнэлэг нь Христчин эмнэлэг бөгөөд Эзэний өдрийн мөргөл ням гаригт үдээс өмнө 10 цаг, Лхагва гаригийн мөргөл лхагва гаригт үдээс хойш 5 цаг, хүүхэд/ өсвөрийн мөргөл нь пүрэв гаригт үдээс өмнө 10 цагт С байрны 3 давхарт Авдар цуглаант болно. Өрөөгөөр зочлох, итгэлийн амьдралын зөвлөгөө, бусад шашны талаарх зөвлөгөө авах талаар лавлахыг хүсвэл зөвлөгөө өгөх төв (02-6986-5724) рүү холбогдох боломжтой ба зөвлөгөө өгөх төв болон залбиралын өрөө нь С байрны 3 давхарт байрлана.
            </p>

            <h4 class="bullet02 type2 num9 depth">Эмнэлэгээс гарах шат дараалал </h4>
            <p class="depth">
                Эмнэлгээс гарах даатгалын шийдвэрийн дараа өвчтөн юмуу асран хамгаалагчид мессэж очих болно. Эмнэлэгээс гарах төлбөрийг удирдлагын хэлтэсийн эмнэлэгт хэвтэх, эмнэлгээс гарах цонхон дээр юмуу төлбөр төлөх машин ашиглан тооцоог хийж төлбөр төлсний дараа эмээ сувилагчаас хүлээн авах боломжтой. 
            </p>

            <h4 class="bullet02 type2 num10 depth">Төрөл бүрийн баталгаажуулах материал гаргаж авах</h4>
            <p class="depth">
                Эмчийн магадлагаа, эмчилгээний бүртгэл болон бичлэгний хуулбар зэрэг шаардлагатай бичиг баримтаа хариуцаж буй эмч болон сувилагчид урьдчилан хэлнэ үү.  
            </p>

            <h4 class="bullet02 type2 num11 depth">Бүх эмчилгээний явцад өвчтөний эрх үүрэг хүндлэгдэн хамгаалагдана.</h4>
            <div class="table mt20">
                <div class="table__inner">
                    <table>
                        <colgroup>
                            <col style="width:50%;">
                            <col style="width:50%;">
                        </colgroup>
                        <thead>
                            <tr>
                                <th>Өвчтөний эрх</th>
                                <th>Өвчтөний үүрэг</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td class="left">
                                    <p class="bullet04 num1">Эмчилгээ хийлгэх эрх</p>
                                </td>
                                <td class="left" rowspan="2">
                                    <p class="bullet04 num1">Эмнэлгийн ажилтанд итгэх, хүндлэх үүрэг </p>
                                </td>
                            </tr>
                            <tr>
                                <td class="left">
                                    <p class="bullet04 num2">Мэдэх эрх болон өөрөө шийдвэр гаргах эрх </p>
                                </td>
                            </tr>


                            <tr>
                                <td class="left">
                                    <p class="bullet04 num3">Нууцаа хамгаалуулах эрх </p>
                                </td>
                                <td class="left" rowspan="3">
                                    <p class="bullet04 num2">Хууль бус аргаар эмчлүүлэхгүй байх үүрэг </p>
                                </td>
                            </tr>
                            <tr>
                                <td class="left">
                                    <p class="bullet04 num4">Зөвлөгөө авах·зохицуулалт хийх хүсэлт гаргах эрх </p>
                                </td>
                            </tr>
                            <tr>
                                <td class="left">
                                    <p class="bullet04 num5">Аюулгүй эмчилгээний орчинд эмчилгээ үйлчилгээ авах эрх </p>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>

            <h4 class="bullet02 type2 num12 depth mt20">
                Өвчтөн болон асран хамгаалагч(зочин) нь ажилтаныг хүчирхийлсэн(хэл амаар доромжлох, дарамтлах, танхайрах, бэлгийн хүчирхийлэл, бэлгийн дарамт, эд зүйл эвдлэх) үйлдэл гаргаж хохирол учруулсан тохиолдолд холбогдох хуулийн дагуу ял шийтгэл хүлээх боломжтой. 
            </h4>

            <h4 class="bullet02 type2 num13 depth mt20">
                Өвчтөн болон асран хамгаалагч нар нь тухайн эмнэлгийн ажилтаныг доромжилсон, нэр хүндэд нь халдсан, хүчирхийлсэн, ажил эрхлэхэд нь саад учруулсан зэрэг нөхцөл байдлыг бий болгож, эмнэлгийн ажилтан нь эмчилгээ үйлчилгээг хэвийн байдлаар хийх боломжгүй болсон тохиолдолд эмнэлгийн хууль болон яаралтай тусламж үйлчилгээний тухай хуулийн хүрээнд эмчилгээ хийхээс татгалзах(эмчилгээ хийхээс татгалзах эрх) боломжтой. 
            </h4>

            <h4 class="bullet02 type2 num14 depth mt20">
                Эмнэлэгт хэвтэж байх үед CCTV-гээр дамжуулан өвчтөний байдлыг ажиглаж, бичлэг хийгдэхгүй болно. 
            </h4>

        </div>

        <div id="step7" class="step-item info">
            <h3 class="bullet01">Эрчимт эмчилгээний тасагт хэвтэх үед шаардлагатай эд зүйлсийн жагсаалт </h3>

            <h4 class="bullet02 depth">Эрчимт эмчилгээний тасагт эргэлтээр орох үед </h4>
            <p class="depth">Эрчимт эмчилгээний тасаг доторх эргэлтийн цаг : өдөр бүр  <span class="font-main">(12:30~12:50)</span></p>

            <h4 class="bullet02 depth">Эрчимт эмчилгээний тасгаас энгийн тасаг руу шилжих үеийн заавар </h4>
            <p class="depth">
                Эрчимт эмчилгээний тасгаас энгийн тасаг руу шилжих үед 24 цагийн турш асрах боломжтой асран хамгаалагч, асрагч шаардлагатай. Алхах боломжтой өвчтөний хувьд тавчик бэлдэнэ үү. 
            </p>

            <h4 class="bullet02 depth">Бусад </h4>
            <p class="depth">
                Нэн яаралтай тусламж авах шаардлагатай өвчтөн бий болох үед эмчилгээний тасгийн шийдвэрийн дагуу цаг хугацаа харгалзахгүйгээр яаралтай эмнэлгийн өрөөнд шилжүүлэх боломжтой. 
            </p>

            <h4 class="bullet02 depth">Эрчимт эмчилгээний тасагт шаардлагатай эд зүйлс</h4>
            <div class="need-item">
                <div class="need-item__text">
                    <p class="bullet04 num1 depth">Эмнэлэгт хэвтэхээс өмнө ууж байсан эм (эмнэлэгийн эм хамаарахгүй)</p>
                    <p class="bullet04 num2 depth">Живх(далавтай, турсик хэлбэрийн биш)</p>
                    <p class="bullet04 num3 depth">Дэвсгэр, нойтон сальфетка (том)</p>
                    <p class="bullet04 num4 depth">Уруул дээр түрхэх вазелин</p>
                    <p class="bullet04 num5 depth">Цаасан аяга, ус 500ml*2 (шаардлагатай тохиолдолд)</p>
                    <p class="bullet04 num6 depth">Ухаан санаа эрүүл байгаа тохиолдолд: шүдний сойз, оо, соруултай усны сав, дөрвөлжин сальфетка</p>


                    <!-- <p class="bullet04 num7 depth"><span><span class="font-main">수술 후 환자의 경우</span>(필요시):트리플로우(호흡기치료기)*1</span></p>
                    <p class="bullet05 depth">지하1층 의료기상사에서 구입가능</p> -->
                </div>
                <div class="need-item__img">
                    <img src="@/assets/resource/img/needitem.png" alt="">
                </div>
            </div>

            <h4 class="bullet02 depth">Эрчимт эмчилгээний тасагт хадгалах боломжгүй үнэт эдлэлийн заавар</h4>
            <p class="depth">
                Эрчимт эмчилгээний тасаг дотор хувийн гар утас ашиглах боломжгүй. Үнэт эдлэлээ алдсан тохиолдолд хариуцлага хүлээхгүй бөгөөд бүх зүйлсээ аваад явахыг хүсч байна. Хиймэл шүд/сонсголын аппарат зүүсэн бол мэдэгдэнэ үү. 
            </p>

            <h4 class="bullet02 depth">Эд зүйл худалдан авах боломжтой газар</h4>
            <p class="bullet03 depth">24 цаг  : <span class="font-main">B1 давхар CU дэлгүүр</span></p>
            <p class="bullet03 depth">Даваа~Баасан 9am~6pm : <span class="font-main">В1 давхар тоног төхөөрөмжийн дэлгүүр</span></p>
        </div>

    </div>
</template>
<script>
    // Import Swiper Vue.js components
    import { Swiper, SwiperSlide } from 'swiper/vue';

    // Import Swiper styles
    import 'swiper/css';

    import 'swiper/css/navigation';
    import 'swiper/css/pagination';

    import { Navigation, Pagination, Mousewheel, Keyboard } from 'swiper/modules';

    export default {
        components: {
            Swiper,
            SwiperSlide,
        },
        setup() {
            return {
                modules: [Navigation, Pagination, Mousewheel, Keyboard],
            };
        },
        data() {
            return {
                lnbIndex: 1,
            };
        },
        mounted() {
            window.addEventListener('scroll', this.handleScroll);
        },
        methods: {
            scrollTo(id) {
                const element = document.getElementById(id);
                if (element) {
                    // 해당 요소의 위치와 크기 정보 가져오기
                    const elementTop = element.getBoundingClientRect().top + window.pageYOffset;

                    // 스크롤을 이동할 위치를 계산 (100px 추가)
                    const scrollToPosition = elementTop - 100;

                    // 계산된 위치로 부드럽게 스크롤
                    window.scrollTo({
                    top: scrollToPosition,
                    behavior: 'smooth'
                    });
                }
            },
            handleScroll() {
                const sections = document.querySelectorAll('.step-item');
                sections.forEach((section, index) => {
                    const rect = section.getBoundingClientRect();
                    // Check if the top of the section is within the viewport
                    if (rect.top <= 101 && rect.top <= window.innerHeight) {
                        this.lnbIndex = index + 1; // Update lnbIndex based on the section's position
                    }
                });
            },
            lnbFn(index) {
                this.lnbIndex = index; // Change the active index when clicking the menu
            },
        },
    };
</script>